import React, {useEffect, useState} from "react";
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import Mint from './components/Mint';
import Shop from './components/Shop';
import Loader from "./components/Loader";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 3000)
  }
  , [])

  
  return (
    <div className="App">
      {
        loading ? (<div className="loader">
          <img src="images/loader.gif" alt="Image not found" />
        </div>) :

        <div className="">
          <Router>
            <Header />
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route exact path="/mint">
                <Mint />
              </Route>
              <Route exact path="/shop">
                <Shop />
              </Route>
            </Switch>
            <Footer />
          </Router>
        </div>
      }
    </div>
  );
}

export default App;
